export const UPDATE_CATEGORIES_LIST     = "UPDATE_CATEGORIES_LIST"    ;
export const UPDATE_CATEGORY_DETAIL_MAP = "UPDATE_CATEGORY_DETAIL_MAP";
export const UPDATE_TOTAL_CATEGORIES    = "UPDATE_TOTAL_CATEGORIES"   ;
export const UPDATE_SELECTED_CATEGORY   = "UPDATE_SELECTED_CATEGORY"  ;
